import { render } from "./TemplateComponent.vue?vue&type=template&id=7b377353"
import script from "./TemplateComponent.vue?vue&type=script&lang=js"
export * from "./TemplateComponent.vue?vue&type=script&lang=js"

import "./TemplateComponent.vue?vue&type=style&index=0&id=7b377353&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__